var $ = require('jquery');

var accordionNames = new Array();
var usingMobileMenu = false;

$(function () {
	initTabbedView();
	initAccordionMode();
	bindClickEvents();
	if (($(window).width() <= 767)) { //checking state on run
		usingMobileMenu = true;
	}
	//timeout for resize/orientation change to help prevent multiple triggers
	var to;
	$(window).on('resize orientationchange', function () {
		clearTimeout(to);
		to = setTimeout(function () {
			checkMenuSwitch();
		}, 100);
	});

});

function checkMenuSwitch() {
	if ((($(window).width() <= 767) && usingMobileMenu === false) || (($(window).width() > 767) && usingMobileMenu === true)) {
		usingMobileMenu = !usingMobileMenu;
		initTabbedView();
		initAccordionMode();
	}
}

function bindClickEvents() {
	//Desktop Tabs
	$('._1910-tabbed-parent__tabs__tab_list__desktop').on('click', '._1910-tabbed-parent__tabs__tab_list__desktop--tab', function (e) {
		e.preventDefault();
		var activeTab = $(this);
		var tab = activeTab.find('._1910-tabbed-parent__tabs__tab_list__desktop--tab-link');
		var tabGUID = tab.data('tab-guid');
		var parent1910 = activeTab.closest('._1910-tabbed-parent');
		parent1910.find('._1910-tabbed-parent__tabs__tab_list__desktop--tab').removeClass('active');
		parent1910.find('._1910-tabbed-parent__tabs__tab_list__desktop__content--section').removeClass('show');
		activeTab.addClass('active');
		$('#' + tabGUID).addClass('show');
	});
	//Mobile Tabs
	$('._1910-tabbed-parent').find('._1910-tabbed-parent__tabs__tab_list__desktop__content--section').on('click', function (e) {
		var t = $(this);
		if (t.closest('._1910-tabbed-parent__tabs').hasClass('accordionView')) {
			e.preventDefault();
			t.siblings('._1910-tabbed-parent__tabs__tab_list__desktop__content--section')
				.children('._1910-tabbed-parent__tab_list__mobile').removeClass('selected')
				.next('._1910-tabbed-parent__tabs__tab_list__desktop__content--section_area').slideUp();
			t.find('._1910-tabbed-parent__tab_list__mobile').toggleClass('selected');
			t.find('._1910-tabbed-parent__tabs__tab_list__desktop__content--section_area').slideToggle();
		}
	});
	
	$('._1910-tabbed-parent__tabs__tab_list__desktop__content--section_area').on('click', function (e) {
		e.stopPropagation();

		//Fix for 1910-310 dropdown filter activation
		if ($(e.target).parent().hasClass("dropdown-filter")) {
			$(e.target).parent().toggleClass("open");
		} else {
			if ($(e.target).hasClass("dropdown-filter-label")) $(e.target).siblings(".dropdown-filter-list").toggleClass("open");
		}
	});

}

function initTabbedView() {
	if ($('._1910-tabbed-parent').length > 0 && $('._1910-tabbed-parent__tabs__tab_list__desktop--tab').length > 1) {

		var tabNames = new Array(); //list of recorded tab names from the querystring
		//run querystring check here
		$('._1910-tabbed-parent').each(function (i) {
			var t = $(this);
			var tabName = t.data('tab-name');
			var paddingBottom = $(t).data("padding-bottom").toString();

			if ($(window).width() > 767) {
				$(t).find("._1910-tabbed-parent__tabs__tab_list__desktop__content").removeClass("accordionView").removeClass(paddingBottom);
			} else {
				$(t).find('._1910-tabbed-parent__tab_list__mobile').removeClass('selected');
			}

			var tabCount = t.find('._1910-tabbed-parent__tabs__tab_list__desktop--tab').length;
			var tabIndex = $.QueryStringTabActivation(tabName, tabCount);
			if (tabIndex !== 999 && (tabNames.indexOf(tabName) === -1)) {
				var newTab = t.find('._1910-tabbed-parent__tabs__tab_list__desktop--tab-link[data-tab-id="' + tabIndex + '"]');
				var newTabContent = $('#' + newTab.data('tab-guid'));
				//deactivate current tab
				t.find('._1910-tabbed-parent__tabs__tab_list__desktop--tab').removeClass('active');
				t.find('._1910-tabbed-parent__tabs__tab_list__desktop__content--section').removeClass('show');
				//activate new one
				newTab.closest('._1910-tabbed-parent__tabs__tab_list__desktop--tab').addClass('active');
				newTabContent.addClass('show');
				$.ScrollToLocation(newTabContent, 400, false);
				tabNames.push(tabName);
			}
		});
	}
}


function initAccordionMode() {
	$('._1910-tabbed-parent').each(function (i) {
		$(this).find('._1910-tabbed-parent__tabs__tab_list__desktop__content--section_area').removeAttr("style");
		var that = $(this);
		var tName = that.data('tab-name');
		var paddingBottom = $(that).data("padding-bottom").toString();
		var tCount = that.find('._1910-tabbed-parent__tabs__tab_list__desktop--tab').length;
		$(that).find("._1910-tabbed-parent__tabs__tab_list__desktop__content").removeClass("accordionView").removeClass(paddingBottom);
		var tIndex = $.QueryStringTabActivation(tName, tCount);
		if ($(window).width() <= 767) {
			MobileAccordionView(that, tName, tIndex, accordionNames, i);
		}
	});
}

function MobileAccordionView(t, tName, tIndex, accordionNames, i) {

	var SetToAccordionField = $(t).data("set-accordion-field");
	var CloseFirstAccordionPaneOnPageLoadField = $(t).data("close-first-accordion");
	var MoveSelectedTabToFirstElementField = $(t).data("move-selected-accordion");

	var isAccordionView = JSON.parse(SetToAccordionField.toLowerCase().toString());
	var isCloseFirstPane = JSON.parse(CloseFirstAccordionPaneOnPageLoadField.toLowerCase().toString());
	var isMoveToFirstPane = JSON.parse(MoveSelectedTabToFirstElementField.toLowerCase().toString());
	var paddingBottom = $(t).data("padding-bottom").toString();

	tIndex = parseInt(tIndex);

	if (isAccordionView) {

		$(t).find("._1910-tabbed-parent__tabs__tab_list__desktop__content").addClass("accordionView").addClass(paddingBottom);

		if (tIndex === 999 || (tIndex !== 999 && accordionNames.includes(tName) && i >= 1)) {
			tIndex = 1;
		}
		if (tIndex === 999 && (accordionNames.includes(tName) && i >= 1)) {
			tIndex = 1;
		}

		var newTabMobile = $(t).find('._1910-tabbed-parent__tabs__tab_list__desktop__content--section[data-tab-number="' + tIndex + '"]');
		var newTabContentMobile = $('#' + newTabMobile.attr('id'));

		$(newTabContentMobile).find('._1910-tabbed-parent__tab_list__mobile').toggleClass('selected');
		$(newTabContentMobile).find('._1910-tabbed-parent__tabs__tab_list__desktop__content--section_area').slideToggle();

		if (!isMoveToFirstPane) {
			$(t).find(".show").addClass("show-normal");
		}

		if (isCloseFirstPane) {
			if (tIndex === 1 || (tIndex !== 999 && isMoveToFirstPane)) {
				$(newTabContentMobile).find('._1910-tabbed-parent__tab_list__mobile').removeClass('selected')
					.next('._1910-tabbed-parent__tabs__tab_list__desktop__content--section_area').slideUp();
			}
		}
		$.ScrollToLocation(newTabMobile, 400, false);
		accordionNames.push(tName);
	}
}